import React, { useState, useRef, useEffect } from "react";
import clsx from 'clsx'

import AppBox from "@/components/AppBox";

interface MenuItem {
  label: string;
  onClick: () => void;
}

interface DropdownMenuProps {
  items: MenuItem[];
  trigger: React.ReactNode;
  className?: string;
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({ items, trigger, className = "" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {      
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleToggleMenu = (event: React.MouseEvent) => {
    event.stopPropagation(); // Prevent clicks from closing the menu
    setIsOpen((prev) => !prev);
  };

  return (
    <AppBox className={clsx("relative", className)} ref={menuRef}>
      {/* Trigger Button */}
      <div onClick={handleToggleMenu} className="cursor-pointer">
        {trigger}
      </div>

      {/* Dropdown Menu */}
      {isOpen && (
        <AppBox
          column
          className="absolute top-full right-0 bg-white shadow-lg rounded mt-2 z-[70]"
        >
          {items.map((item, index) => (
            <button
              key={index}
              onClick={() => {
                setIsOpen(false);
                item.onClick();
              }}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 capitalize"
            >
              {item.label}
            </button>
          ))}
        </AppBox>
      )}
    </AppBox>
  );
};

export default DropdownMenu;